// extracted by mini-css-extract-plugin
module.exports = {"root":"NameTenat_root__3I2EK","title":"NameTenat_title__7aWBs","text":"NameTenat_text__3fFSS"};